import { render, staticRenderFns } from "./VillageList.vue?vue&type=template&id=6ebc68b0&scoped=true"
import script from "./VillageList.vue?vue&type=script&lang=js"
export * from "./VillageList.vue?vue&type=script&lang=js"
import style0 from "./VillageList.vue?vue&type=style&index=0&id=6ebc68b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebc68b0",
  null
  
)

export default component.exports